import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.button`
  width: 46px;
  height: 46px;
  background-color: rgba(74, 62, 94, 0.95);
  border-radius: 12px;
  border: 0;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const Icon = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
`;

type OpenFilter = {
  open?: boolean;
};

export const Popup = styled.div<OpenFilter>`
  position: absolute;
  top: 68px;
  right: -20px;
  z-index: 1;

  @media (max-width: 1096px) {
    left: -20px;
  }

  ${({ open }) =>
    !open &&
    css`
      display: none;
    `}
`;

export const BallonLeg = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 14.5px 11px 14.5px;
  border-color: transparent transparent rgba(255, 255, 255, 0.1) transparent;
  position: absolute;
  top: -11px;
  right: 27px;
`;

export const Ballon = styled.div`
  width: calc(365px - 40px);
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: rgba(74, 62, 94, 0.95);

  @media (max-width: 384px) {
    width: 250px;
  }

  @media (max-width: 309px) {
    width: 200px;
  }
`;

export const Title = styled.h3`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0.005em;
  color: ${({ theme }) => theme.palette.text.white};
  margin-bottom: 18px;
`;

export const Line = styled.div`
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin-top: 30px;
  margin-bottom: 14px;
`;

export const Filter = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18.8513px;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.text.white};
  margin-top: 5px;

  & + & {
    margin-top: 22px;
  }
`;
